import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/modal';
import Button from 'shared/button';
import './teams.scss';
import { formatPhoneNumber } from 'helpers/formatters/phone_number_formats';

export default function TeamMemberModal({
  editOrCreateTeamMember,
  newTeamMember,
  modalOpen,
  setTeamMember,
  teamMember,
  onModalClose
}) {
  const updateTeamMemberValues = (value, field) => {
    const updatedTeamMember = { ...teamMember, [field]: value };
    setTeamMember(updatedTeamMember);
  };

  const modalTitle = newTeamMember ? 'New Team Member' : 'Edit Team Member';
  const actionButtonText = newTeamMember ? 'Add Team Member' : 'Update Team Member';

  const invalidForm = teamMember.name === '' || teamMember.email === '';

  return (
    <Modal show={modalOpen} onHide={onModalClose}>
      <Modal.Header closeButton>{modalTitle}</Modal.Header>
      <Modal.Body>
        <div className="team-member-modal">
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-name">Name<span className="text-red"> *</span></label>
            <input
              autoFocus
              className="form-control"
              id="team-member-name"
              type="text"
              value={teamMember.name}
              onChange={e => updateTeamMemberValues(e.target.value, 'name')}
            />
          </div>
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-job-title">Job Title</label>
            <input
              className="form-control"
              id="team-member-job-title"
              type="text"
              value={teamMember.jobTitle}
              onChange={e => updateTeamMemberValues(e.target.value, 'jobTitle')}
            />
          </div>
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-phone-number">Phone Number</label>
            <input
              className="form-control"
              id="team-member-phone-number"
              type="text"
              value={formatPhoneNumber(teamMember.phoneNumber)}
              onChange={e => updateTeamMemberValues(formatPhoneNumber(e.target.value), 'phoneNumber')}
            />
          </div>
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-cell-phone-number">Cell Phone Number</label>
            <input
              className="form-control"
              id="team-member-cell-phone-number"
              type="text"
              value={formatPhoneNumber(teamMember.cellPhoneNumber)}
              onChange={e => updateTeamMemberValues(formatPhoneNumber(e.target.value), 'cellPhoneNumber')}
            />
          </div>
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-email">Email<span className="text-red"> *</span></label>
            <input
              className="form-control"
              id="team-member-email"
              type="text"
              value={teamMember.email}
              onChange={e => updateTeamMemberValues(e.target.value, 'email')}
            />
          </div>
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-office-name">Office Name</label>
            <input
              className="form-control"
              id="team-member-office-name"
              type="text"
              value={teamMember.officeName}
              onChange={e => updateTeamMemberValues(e.target.value, 'officeName')}
            />
          </div>
          <div className="form-group">
            <label className="d-block" htmlFor="team-member-license-number">License Number</label>
            <input
              className="form-control"
              id="team-member-license-number"
              type="text"
              value={teamMember.licenseNumber}
              onChange={e => updateTeamMemberValues(e.target.value, 'licenseNumber')}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button.Primary disabled={invalidForm} onClick={editOrCreateTeamMember}>
          {actionButtonText}
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

TeamMemberModal.propTypes = {
  editOrCreateTeamMember: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  newTeamMember: PropTypes.bool.isRequired,
  setTeamMember: PropTypes.func.isRequired,
  teamMember: PropTypes.shape({
    cellPhoneNumber: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    jobTitle: PropTypes.string,
    officeName: PropTypes.string,
    phoneNumber: PropTypes.string,
    licenseNumber: PropTypes.string,
  }).isRequired,
  onModalClose: PropTypes.func.isRequired
};
